import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: () => import('@/views/AppWithHeaderFooter.vue'),
        children: [
            {
                path: '/',
                component: () => import('@/views/Home.vue')
            },
            {
                path: '/opendata',
                component: () => import('@/views/OpenData.vue')
            },
            {
                path: '/vermessungsstelle',
                component: () => import('@/views/Vermessungsstelle.vue')
            },
            {
                path: '/datenschutz',
                component: () => import('@/views/Datenschutz.vue')
            },
            {
                path: '/bestellformular/:usergroup',
                component: () => import('@/views/Bestellformular.vue'),
                props: (route) => ({
                    usergroupSelected: route.params.usergroup
                })
            },
            {
                path: '/hilfe',
                component: () => import('@/views/Hilfe.vue')
            },
            {
                path: '/barrierefreiheit',
                component: () => import('@/views/Barrierefreiheit.vue')
            },
            {
                path: '/wartung',
                component: () => import('@/views/Wartung.vue')
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
